module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4I0Hy"))).then(() => parcelRequire('37nVf'));